import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import MediaPickerImageCard from '../../../common/MediaPickerImageCard';
import { MEDIA_SOURCE_TYPE, MEDIA_USAGE_TYPE } from '../../../../CreatePageConstants';
import { readBase64FromURL } from '../../../../../../../utilities/fileUtilities';
import { createActions } from '../../../../store';

const BackgroundStockImagesCard = (props) => {
    const { 
        galleryCardWidth, galleryCardHeight, backgroundStockImage, showImageCropper,
        savingInProgress, showCriticalOperationProgressWarning, isVideoExportsQueued
    } = props;

    const onImageClick = () => { 
        if (savingInProgress) {
            showCriticalOperationProgressWarning();
            return;
        }

        if (isVideoExportsQueued())
            return;
        
        readBase64FromURL(backgroundStockImage.originalUrl, (base64) => {
            showImageCropper(
                base64, 
                'jpeg', 
                MEDIA_SOURCE_TYPE.STOCK_IMAGE, 
                MEDIA_USAGE_TYPE.BACKGROUND,
                backgroundStockImage.id,
                backgroundStockImage.originalUrl
            );
        });
    };

    return (
        <MediaPickerImageCard 
            image={backgroundStockImage}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
            onImageClick={onImageClick}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const backgroundStockImage = state.mediaPicker.backgroundStockImages[ownProps.index];
    const { savingInProgress } = state.create.videoSavingState;
    return { backgroundStockImage, savingInProgress };
}

const mapDispatchToProps = (dispatch) => {
    const isVideoExportsQueued = () => dispatch(createActions.isVideoExportsQueued());
    const showImageCropper = (data, format, mediaSourceType, mediaUsageType, mediaResourceId, mediaResourceUrl) => dispatch(mediaPickerActions.showImageCropper(data, format, mediaSourceType, mediaUsageType, mediaResourceId, mediaResourceUrl));
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return { 
        showImageCropper,
        isVideoExportsQueued,
        showCriticalOperationProgressWarning 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundStockImagesCard);